import { useMutation } from "react-query";
import { LoyaltyApi } from "@jti/rest-api";
export const useSubmitContest = () => useMutation(({ uuid, ciam_token, formData }) => LoyaltyApi.init().postContest(uuid, ciam_token, formData));
//# sourceMappingURL=useSubmitContest.js.map